import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { CurrentUserRolesProvider } from '../../organizations/providers/current-user-roles-provider';
import { OrganizationsProvider } from '../../organizations/providers/organizations-provider';
import { CurrentUser } from "../providers/current-user";
import { AthletesProvider } from "../../athletes/providers/athletes-provider";
import { Organization } from "../models/organization";
import { Observable, of, switchMap } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { Athlete } from "../models/athlete";

@Injectable({
  providedIn: 'root'
})
export class AthleteViewGuardService implements CanActivate {
    private roleAthleteId = 4;

    constructor(
        private router: Router,
        private currentUser: CurrentUser,
        private currentUserRoles: CurrentUserRolesProvider,
        private organizationsProvider: OrganizationsProvider,
        private athleteProvider: AthletesProvider
    ) {
    }

    public canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> {
      const code = route.paramMap.get('organizationCode');
      if (!code) return of(true);
      return this.organizationsProvider.getByCode(code).pipe(
        switchMap((organization: Organization) => {
          const roles = this.currentUserRoles.getRolesIds(organization.id!);
          if (roles.includes(this.roleAthleteId) && route.url[1]?.path !== 'app') {
            return this.athleteProvider.get(organization.id!, this.currentUser.user!.id!).pipe(
              map((athlete) => {
                  this.router.navigateByUrl(`${route.paramMap.get('organizationCode')}/app/athletes/${athlete.id}`);
                  return false;
              }),
              catchError(() => of(true)) // In case of an error, resolve to true to allow navigation
            );
          } else {
            return of(true);
          }
        }),
        catchError(() => of(true)) // In case of an error, resolve to true to allow navigation
      );
    }
}
